<template>
  <div>
    <van-nav-bar
      title="资金提现"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/agency')"
    />
    <van-form @submit="Withdrawal">
      <van-cell title="佣金金额">
        <template #default>
          <span>{{ agent_account }}美元</span>
        </template>
      </van-cell>
      <van-field
        v-model="money"
        error
        required
        type="digit"
        label="提现金额"
        placeholder="请输入提现金额"
        input-align="right"
      />
      <van-field
        v-model="password"
        error
        required
        type="password"
        label="提现密码"
        placeholder="请输入提现密码"
        input-align="right"
      />
      <van-button size="small" round  type="danger" block>提现</van-button>
    </van-form>
  </div>
</template>

<script>
  export default {
    name: "AgencyWithdrawal",
    data() {
      return {
        agent_account: 0.00,
        money: '',
        password:''
      }
    },
    methods: {
      isLogin(){
        let that = this;
        if (!that.$store.state.loginType){
          that.$router.push('/login')
        }
      },
      getUser() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token")
            }
          })
          .then(function (res) {
            let resData = res.data;
            if (res.data.code === 1) {
              that.agent_account = resData.data.agent_account;
            } else if (res.data.code === 0 || res.data.code === -1) {
              that.$toast.fail(that.$t(resData.msg));
            }
          });
      },
      Withdrawal() {
        let that = this;
        that.$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "accountbank",
            token: sessionStorage.getItem("token")
          }
        })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              if (resData.data.length === 0){
                that.$toast({
                  type:'fail',
                  message:that.$t('app.agency_transfer_withdrawal.bind_bank'),
                  onClose:function () {
                    that.$router.push('/member/information');
                  }
                });
              }else{
                let bankCardList = res.data.data;
                // that.bankCardList = res.data.data;
                let card = bankCardList[0].card;
                let name = bankCardList[0].name;

                that.$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "agent_dowithdraw",
                    token: sessionStorage.getItem("token"),
                    number: that.money,
                    password: that.password,
                    name: name,
                    card: card
                  }
                })
                  .then(function(res) {
                    if (res.data.code == 1) {
                      that.$toast.success({
                        message: that.$t(res.data.msg),
                        onClose:function () {
                          that.$router.push('/member/agency')
                        }
                      });
                    } else if (res.data.code == 0 || res.data.code == -1) {
                      that.$toast.fail(that.$t(res.data.msg));
                    }
                  });
              }


            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(that.$t(res.data.msg));
            }
          });

      }
    },
    mounted: function () {
      this.isLogin();
      this.getUser();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AgencyWithdrawal.vue